import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import "./Payment.css";

const API_URL = "https://payyug.in/api";

const Payment = () => {
  const [branchs, setBranchs] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [debitAccount, setDebitAccount] = useState([]);
  const [selectedDebitAccount, setSelectedDebitAccount] = useState(null);
  const [ledger, setLedger] = useState([]);
  const [selectedLedger, setSelectedLedger] = useState(null);

  const [formData, setFormData] = useState({
    date: "",
    narration: "",
    amount: "",
    ledgerType: "",
  });

  /* ================= FETCH BRANCH ================= */
  useEffect(() => {
    const fetchBranch = async () => {
      try {
        const res = await axios.get(`${API_URL}/get-branch`, {
          params: {
            SuperAdminId: localStorage.getItem("adminuserId"),
            limit: "all",
          },
        });
        console.log("branch", res.data.branches);
        setBranchs(res?.data?.branches || []);
      } catch (err) {
        console.error(err);
      }
    };

    fetchBranch();
  }, []);

  /* ================= FETCH BRANCH LEDGER LIST================= */
  useEffect(() => {
    if (!selectedBranch) {
      setLedger([]);
      setDebitAccount([]);
      return;
    }
    const fetchLedger = async () => {
      try {
        const res = await axios.get(`${API_URL}/ledger/getall`, {
          params: {
            superAdminId: localStorage.getItem("adminuserId"),
              // branch_id: selectedBranch.id,
              limit:100000,
          },
        });

const debitLedger = res?.data?.rows?.filter(
  (dl) => dl.name.toLowerCase() === "cash"
);
const ledger = res?.data?.rows?.filter(
  (l) => l.name.toLowerCase() !== "cash" && l.name.toLowerCase() !== "bank"
);
setLedger(ledger || []);
setDebitAccount(debitLedger || []);
      } catch (err) {
        console.error(err);
      }
    };

    fetchLedger();
  }, [selectedBranch]);

  /* ================= HANDLE CHANGE ================= */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  /* ================= SUBMIT ================= */
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedBranch) {
      toast.error("Please select branch");
      return;
    }

    if (!selectedLedger) {
      toast.error("Please select Ledger");
      return;
    }

    if (!formData.amount) {
      toast.error("Amount is required");
      return;
    }

    const adminId = Number(localStorage.getItem("adminuserId"));

    const payload = {
      voucherType: "payment",
      voucherNo: `PAY${Date.now()}`,
      date: formData.date,
      narration: formData.narration,
      branchId: selectedBranch.id,
      superAdminId: adminId,
      createdBy: adminId,
      paymentAccountLedgerId: selectedDebitAccount?.id,
      entry: {
        ledgerId: Number(selectedLedger?.id),
        amount: Number(formData.amount),
        ledgerType: selectedLedger.name,

      },
    };

    try {
      const res=await axios.post(`${API_URL}/ledger-entry/create-voucher-new`, payload);

      toast.success(res?.data?.message||"Payment Voucher Created Successfully");

      // reset
      setFormData({
        date: "",
        narration: "",
        amount: "",
        ledgerType: "",
      });

      setSelectedBranch(null);
      setSelectedLedger(null);
    } catch (err) {
      console.error(err);
      toast.error(
        err?.response?.data?.message || "Failed to create payment voucher"
      );
    }
  };

  return (
    <div className="payment-container">
      <h1 className="payment-heading">Payment Voucher</h1>

      <div className="payment-top">
        <form className="payment-form" onSubmit={handleSubmit}>
          <div className="payment-form-section">
            {/* Branch */}
            <div className="payment-form-input-fields">
              <label>Branch</label>
              <select
                value={selectedBranch?.id || ""}
                onChange={(e) => {
                  const branch = branchs.find(
                    (br) => br.id === Number(e.target.value)
                  );
                  setSelectedBranch(branch);
                }}
              >
                <option value="">Select Branch</option>
                {branchs.map((b) => (
                  <option key={b.id} value={b.id}>
                    {b.name}
                  </option>
                ))}
              </select>
            </div>

            {/* Date */}
            <div className="payment-form-input-fields">
              <label>Date</label>
              <input
              required
                type="date"
                name="date"
                value={formData.date}
                onChange={handleChange}
              />
            </div>

            {/* DR Account */}
            <div className="payment-form-input-fields">
              <label>Payment Type</label>
              <select
              disabled={!selectedBranch}
                value={selectedDebitAccount?.id || ""}
                onChange={(e) => {
                  const debitLedger = debitAccount.find(
                    (bl) => bl.id === Number(e.target.value)
                  );
                  setSelectedDebitAccount(debitLedger);
                }}
              >
                <option value="">Select Payment Type</option>
                {debitAccount.map((bl) => (
                  <option key={bl.id} value={bl.id}>
                    {bl.name}
                  </option>
                ))}
              </select>
            </div>

            {/* Ledger */}
            <div className="payment-form-input-fields">
              <label>Ledger</label>
              <select
              disabled={!selectedBranch}
                value={selectedLedger?.id || ""}
                onChange={(e) => {
                  const ledgerData = ledger.find(
                    (bl) => bl.id === Number(e.target.value)
                  );
                  setSelectedLedger(ledgerData);
                }}
              >
                <option value="">Select Ledger</option>
                {ledger.map((bl) => (
                  <option key={bl.id} value={bl.id}>
                    {bl.name}
                  </option>
                ))}
              </select>
            </div>

            {/* Amount */}
            <div className="payment-form-input-fields">
              <label>Amount</label>
              <input
                type="number"
                name="amount"
                value={formData.amount}
                onChange={handleChange}
              />
            </div>
          </div>

          {/* Narration */}
          <div className="payment-narration-input">
            <label>Narration</label>
            <textarea
            required
              name="narration"
              value={formData.narration}
              onChange={handleChange}
            />
          </div>

          <div className="payment-form-submit-btn">
            <button type="submit">Save</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Payment;
